__turbopack_context__.v({
  "bullet": "Carousel-module-scss-module__PjFr8a__bullet",
  "c_slide_active": "Carousel-module-scss-module__PjFr8a__c_slide_active",
  "carouselContainer": "Carousel-module-scss-module__PjFr8a__carouselContainer",
  "carouselWrapper": "Carousel-module-scss-module__PjFr8a__carouselWrapper",
  "controls": "Carousel-module-scss-module__PjFr8a__controls",
  "default_carousel_pagination": "Carousel-module-scss-module__PjFr8a__default_carousel_pagination",
  "freeModeCarouselContainer": "Carousel-module-scss-module__PjFr8a__freeModeCarouselContainer",
  "freeModeCarouselWrapper": "Carousel-module-scss-module__PjFr8a__freeModeCarouselWrapper",
  "row": "Carousel-module-scss-module__PjFr8a__row",
  "slideGrid": "Carousel-module-scss-module__PjFr8a__slideGrid",
  "smoothBehaviour": "Carousel-module-scss-module__PjFr8a__smoothBehaviour",
});
